import { loadingAction } from 'store/globalState/global';
import apiFetch from 'utils/apiFetch';
import * as ACTION_TYPE from './types';

export const getElementsCreatedByUser = elementTypes => (dispatch) => {
  const params = { element_types: elementTypes };

  dispatch({ type: ACTION_TYPE.GET_ELEMENTS_CREATED_BY_USER_INIT });
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'users/elements_created' }, params)
    .then((response) => {
      dispatch({
        type: ACTION_TYPE.GET_ELEMENTS_CREATED_BY_USER_SUCCESS,
        payload: {
          elements: response.data,
        },
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_ELEMENTS_CREATED_BY_USER_FAILURE });
      dispatch(loadingAction(false));
    });
};

export const postElementByUser = params => (dispatch) => {
  dispatch({ type: ACTION_TYPE.POST_ELEMENTS_CREATED_BY_USER_INIT });
  dispatch(loadingAction(true));
  apiFetch('POST', { endPoint: 'users/elements_created' }, params)
    .then(() => {
      dispatch({
        type: ACTION_TYPE.POST_ELEMENTS_CREATED_BY_USER_SUCCESS,
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_ELEMENTS_CREATED_BY_USER_FAILURE });
      dispatch(loadingAction(false));
    });
};
export const getElementById = elementId => (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_ELEMENT_BY_ID_INIT });
  const params = { id: elementId };
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'users/element_created' }, params)
    .then((response) => {
      dispatch({
        type: ACTION_TYPE.GET_ELEMENT_BY_ID_SUCCESS,
        payload: {
          element: response.data,
        },
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_ELEMENT_BY_ID_FAILURE });
      dispatch(loadingAction(false));
    });
};

export const getElementsSelected = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_ELEMENTS_SELECTED_INIT });
  const params = {};
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'elements/selected' }, params)
    .then((response) => {
      dispatch({
        type: ACTION_TYPE.GET_ELEMENTS_SELECTED_SUCCESS,
        payload: {
          element: response.data,
        },
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_ELEMENTS_SELECTED_FAILURE });
      dispatch(loadingAction(false));
    });
};

export const getUserInterests = id => (dispatch) => {
  dispatch({ type: ACTION_TYPE.GET_USER_INTERESTS_INIT });
  const params = {
    id,
  };
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: `user/${id}/interest` }, params)
    .then((response) => {
      dispatch({
        type: ACTION_TYPE.GET_USER_INTERESTS_SUCCESS,
        payload: response,
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: ACTION_TYPE.GET_USER_INTERESTS_FAILURE });
      dispatch(loadingAction(false));
    });
};

export const connectWithElement = (narrativeType, element) => (dispatch) => {
  const params = {
    narrativeType,
    type: element.type,
    name: element.name,
  };

  dispatch({ type: ACTION_TYPE.ADD_SELECTED_ELEMENT, payload: element });

  return apiFetch('POST', { endPoint: 'elements/connection' }, params);
};

export const removeConnectionWithElement = (narrativeType, element) => (dispatch) => {
  const params = {
    narrativeType,
    type: element.type,
    name: element.name,
  };

  dispatch({ type: ACTION_TYPE.REMOVE_SELECTED_ELEMENT, payload: element });

  return apiFetch('DELETE', { endPoint: 'elements/connection' }, params);
};

export const getElementTypesShownInUserCard = () => (dispatch) => {
  apiFetch('GET', { endPoint: 'element_types' }, { show_in_user_card: 1 })
    .then((response) => {
      dispatch({ type: ACTION_TYPE.SET_ELEMENT_TYPES_SHOWN_IN_USER_CARD, payload: response.data });
    });
};



// WEBPACK FOOTER //
// ./src/modules/elements/actions.js